// import React, { useEffect, useState } from "react";
// import "./Photos.css";
// import { url } from "../Api/config";
// import { fetchPhotos } from "../Api/photos";

// const Photos = () => {
//   const [photos, setPhotos] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchPhotos()
//       .then(data => {
//         setPhotos(data);
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error("Ошибка загрузки фотографий:", err);
//         setLoading(false);
//       });
//   }, []);

//   return (
//     <div className="photos-container roboto-condensed-1">
//       <h2 className="photos-title">Наши фотографии</h2>
//       {loading ? (
//         <p>Загрузка фотографий...</p>
//       ) : (
//         <div className="photos-row">
//           {photos.map((src, index) => (
//             <div key={index} className="photo-box">
//               <img src={url + src} alt={`Фото ${index + 1}`} className="photo-img" />
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Photos;


import React, { useEffect, useState } from "react";
import "./Photos.css";
import { url } from "../Api/config";
import { fetchPhotos } from "../Api/photos";

const Photos = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPhotos()
      .then(data => {
        console.log("Фотографии получены:", data);
        setPhotos(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Ошибка загрузки фотографий:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="photos-container roboto-condensed-1">
      <h2 className="photos-title">Наши фотографии</h2>
      {loading ? (
        <div className="photos-loader">Загрузка фотографий...</div>
      ) : (
        <div className="photos-row">
          {photos.map((src, index) => (
            <div key={index} className="photo-box">
              <img
                src={url + src}
                alt={`Фото ${index + 1}`}
                className="photo-img"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Photos;

